import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, ModelObjectWithDirtyCheck, type ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"
import { EnumDocumentFileType } from "./enums/enumDocumentFileType.generated";
import { EnumDocumentType } from "./enums/enumDocumentType.generated";

// Model Objects

export class LabelTemplateAndQuantity extends ModelObject<LabelTemplateAndQuantity> {

    public labelDocumentType: EnumDocumentType = EnumDocumentType.none;
    public labelDocumentTemplateId: Guid = Guid.createEmpty();
    public quantity: number = 0;

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.labelDocumentType = EnumDocumentType.getByValue(jsonSerializedObject.labelDocumentType, this.labelDocumentType);
          this.labelDocumentTemplateId = Guid.parseOrEmpty(jsonSerializedObject.labelDocumentTemplateId);
          this.quantity = jsonSerializedObject.quantity;
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.labelDocumentType = this.labelDocumentType.value;
        toRet.labelDocumentTemplateId = this.labelDocumentTemplateId.toString();
        toRet.quantity = this.quantity;
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
            {field: "labelDocumentTemplateId", rule: (v: any) => !v.isEmpty() || "LabelTemplateAndQuantity.LabelDocumentTemplateId cannot be empty"},
            {field: "quantity", rule: (v: any) => v == null || v >= -2147483648 || "Quantity is not greater than minimum allowed value: -2147483648"},
            {field: "quantity", rule: (v: any) => v == null || v <= 2147483647 || "Quantity is above maximum allowed value: 2147483647"},
    ];
}


export class ContainerLabelService extends ServiceBase {

  public async generateContainerLabels(stockItemId: Guid, urn: string, bestBeforeDate: LocalDate | null, documentFormat: EnumDocumentFileType, packagedOn: LocalDate, processSubBatch: string, labelTemplateAndQuantity: readonly LabelTemplateAndQuantity[], opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<Uint8Array> {
    const req = {
    tenantId:api.tenantId.toString(),
    stockItemId:stockItemId.toString(),
    urn:urn,
    bestBeforeDate:bestBeforeDate == null ? null : bestBeforeDate.toString(),
    documentFormat:documentFormat.value,
    packagedOn:packagedOn.toString(),
    processSubBatch:processSubBatch,
    labelTemplateAndQuantity:labelTemplateAndQuantity.map(v => v.toJsonSerializedObject()),
    };
    const extractor = (response:any) => converters.base64ToUint8Array(response.documentBytes);;
    return this.makeJsonRequest("containerLabel/v1/generateContainerLabels", req, false, extractor, opts);
  };
}

export const containerLabelService = new ContainerLabelService();